module.exports = __webpack_public_path__ + "assets/img/hero.b080f539.jpg";